import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { OptionService } from '../../../services/option.service';
import { Subscription } from 'rxjs';

declare var swal: any;

@Component({
  selector: 'app-maintenance-status',
  templateUrl: './maintenance-status.component.html',
  styleUrls: ['./maintenance-status.component.css']
})
export class MaintenanceStatusComponent implements OnInit {
  currentStatus: String;

  subscriptionStatus: Subscription;
  subscriptionOperation: Subscription;

  constructor(private optionService: OptionService) { }

  @ViewChild('code') code: ElementRef;

  ngOnInit() {
    this.optionService.httpGetMaintenance();

    this.subscriptionStatus = this.optionService.maintenanceChanged.subscribe(
      (maintenance: any) => {
        if(typeof maintenance.ID != 'undefined'){
          if(maintenance.value == 0){
            this.currentStatus = 'Online';
          } else {
            this.currentStatus = 'Offline';
          }
        }
      }
    );

    this.subscriptionOperation = this.optionService.optionOperation.subscribe(
      (maintenance: any) => {
        if(typeof maintenance.ID != 'undefined'){
          location.reload();
        }
      }
    );

  }

  onChangeStatus(){
    let data = {
      code: this.code.nativeElement.value
    }

    this.optionService.httpPutMaintenance(data);
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/maintenance/maintenance-status/maintenance-status.component.ts